import {
  drugtransaction_carts_active_read,
  drugtransaction_carts_active_items_create,
  drugtransaction_carts_active_items_list,
  drugtransaction_carts_active_items_partial_update,
  drugtransaction_carts_active_items_delete,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";
import get from "lodash/get";

import Vue from "vue";

function getCartProductsInLocalStorage() {
  try {
    return JSON.parse(localStorage.getItem("shoppingcartproducts")) || {};
  } catch (_) {
    return {};
  }
}

export default {
  namespaced: true,
  state: {
    cart: {},
    // Cuando se realizan peticiones a la api y se espera que haya cambios
    // en los datos, seteamos esto a true para que en los componentes podamos
    // mostrar un feedback mientras se procesan los datos
    active_cart_is_busy: false,
    delivery_address: undefined,
    purchase_options: {},
    products:
      getCartProductsInLocalStorage() ||
      {
        /*
      priceUuid1: {
        product_uuid: productUuid1,
        quantity: 1,
        name: "Product 1",
        picture: "product1.jpg",
        price: {
          currency: "MXN",
          price: 50
        }
      },
      priceUuid2: {
        product_uuid: productUuid1,
        quantity: 5,
        name: "Product 1",
        picture: "product1.jpg",
        price: {
          currency: "MXN",
          price: 25
        }
      },
      priceUuid3: {
        product_uuid: productUuid2,
        quantity: 20,
        name: "Product 2",
        picture: "product2.jpg",
        price: {
          currency: "MXN",
          price: 100
        }
      }
      */
      },
    notify: 0, // it's a timestamp, so I don't need to clear the field
  },
  actions: {
    REQUEST_ACTIVE_CART: ({ commit }) => {
      commit("MUTATE_ACTIVE_CART_IS_BUSY", true);
      return new Promise((resolve, reject) => {
        drugtransaction_carts_active_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            var cart = response.data;
            commit("MUTATE_CART", cart);
            commit("MUTATE_PRODUCTS", cart.item_list.drugs);
            commit("MUTATE_ACTIVE_CART_IS_BUSY", false);
            resolve(response);
          },
          err => {
            reject(err);
            commit("MUTATE_ACTIVE_CART_IS_BUSY", false);
          }
        );
      });
    },
    REPEAT_ORDER: ({ dispatch }, order) => {
      return new Promise(reject => {
        order.item_list.drugs.forEach(product => {
          dispatch("ADD_PRODUCT", {
            product: product.parent,
            price: { uuid: product.price.price_uuid },
            quantity: product.quantity,
          }).then(err => {
            reject(err);
          });
        });
      });
    },
    REQUEST_ACTIVE_CART_PRODUCTS: ({ commit }) => {
      return new Promise(resolve => {
        drugtransaction_carts_active_items_list({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(response => {
          commit("MUTATE_PRODUCTS", response.data.results);
          resolve(response);
        });
      });
    },
    ADD_PRODUCT: ({ commit, rootGetters, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        var quantity = Number(payload.quantity);
        if (!quantity || quantity <= 0) {
          quantity = 1;
        }
        var price = Object.assign({}, payload.price);
        var product = Object.assign({}, payload.product, {
          price: price,
          quantity: quantity,
          dirty: true,
        });

        if (
          product.can_buy_only_if_has_logged &&
          !rootGetters["auth/isAuthenticated"]
        ) {
          reject({ e: "can_buy_only_if_has_logged" });
          return;
        }

        commit("MUTATE_NEW_PRODUCT", {
          product: product,
        });

        if (rootGetters["auth/isAuthenticated"]) {
          // Request new product to the backend

          drugtransaction_carts_active_items_create({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
            data: {
              price_uuid: payload.price.uuid,
              quantity: quantity,
            },
          }).then(
            response => {
              commit("NOTIFY");
              commit("MUTATE_ITEM_UUID", {
                item: response.data,
              });
              // Actualizamos el carro, total, etc
              return dispatch("REQUEST_ACTIVE_CART").then(
                response => {
                  return resolve(response);
                },
                err => {
                  commit("MUTATE_PRODUCT_QUANTITY", {
                    price_uuid: payload.price_uuid,
                    quantity: payload.previous_quantity,
                  });
                  return reject(err);
                }
              );
            },
            err => {
              product.quantity -= product.quantity;
              if (product.quantity <= 0) {
                commit("MUTATE_REMOVE_PRODUCT", {
                  price_uuid: payload.price.uuid,
                });
              } else {
                commit("MUTATE_NEW_PRODUCT", {
                  product: product,
                });
              }
              reject(err);
            }
          );
        } else {
          commit("NOTIFY");
          resolve({ data: product });
        }
      });
    },
    ADD_PRODUCTS_FROM_LOCALSTORAGE: ({ commit }) => {
      commit("MUTATE_ACTIVE_CART_IS_BUSY", true);
      var products = Object.values(getCartProductsInLocalStorage());
      let promises = [];
      if (products.length > 0) {
        products.forEach(item => {
          if (!item.price || !item.price.uuid || !item.quantity) {
            return;
          }
          let onepromise = drugtransaction_carts_active_items_create({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
            data: {
              price_uuid: item.price.uuid,
              quantity: item.quantity,
            },
          });
          promises.push(onepromise);
        });
      } else {
        commit("MUTATE_ACTIVE_CART_IS_BUSY", false);
        return [
          new Promise(resolve => {
            resolve({ data: [] });
          }),
        ];
      }
      Promise.allSettled(promises).then(
        () => {
          commit("MUTATE_ACTIVE_CART_IS_BUSY", false);
        },
        () => {
          commit("MUTATE_ACTIVE_CART_IS_BUSY", false);
        }
      );
      return promises;
    },
    SET_QUANTITY: ({ commit, rootGetters, dispatch }, payload) => {
      // Send new quantity to the backend
      // We commit without waiting for avoiding lag problems with number inputs and arrows
      commit("MUTATE_PRODUCT_QUANTITY", {
        price_uuid: payload.price_uuid,
        quantity: payload.quantity,
      });
      if (rootGetters["auth/isAuthenticated"]) {
        // TODO: hacer esto en una sóla consulta
        return new Promise((resolve, reject) => {
          drugtransaction_carts_active_items_partial_update({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
            itemUuid: payload.item_uuid,
            data: {
              quantity: payload.quantity,
            },
          }).then(
            () => {
              return dispatch("REQUEST_ACTIVE_CART").then(
                response => {
                  return resolve(response);
                },
                err => {
                  commit("MUTATE_PRODUCT_QUANTITY", {
                    price_uuid: payload.price_uuid,
                    quantity: payload.previous_quantity,
                  });
                  return reject(err);
                }
              );
            },
            err => {
              commit("MUTATE_PRODUCT_QUANTITY", {
                price_uuid: payload.price_uuid,
                quantity: payload.previous_quantity,
              });
              return reject(err);
            }
          );
        });
      }
    },
    REMOVE_PRODUCT: ({ commit, rootGetters, dispatch }, payload) => {
      commit("MUTATE_REMOVE_PRODUCT", { price_uuid: payload.price_uuid });
      if (rootGetters["auth/isAuthenticated"]) {
        return new Promise((resolve, reject) => {
          drugtransaction_carts_active_items_delete({
            $config: axconf(),
            role: "vooyguest",
            roleUuid: "1",
            itemUuid: payload.item_uuid,
          }).then(
            () => {
              return dispatch("REQUEST_ACTIVE_CART").then(
                response => {
                  return resolve(response);
                },
                err => {
                  return reject(err);
                }
              );
            },
            err => {
              return reject(err);
            }
          );
        });
      }
    },
    RESET_CART: ({ commit, dispatch }) => {
      commit("MUTATE_PRODUCTS", []);
      dispatch("REQUEST_ACTIVE_CART");
    },
    CLEAR_CART: ({ commit }) => {
      commit("MUTATE_PRODUCTS", []);
    },
  },
  mutations: {
    MUTATE_ACTIVE_CART_IS_BUSY: (state, status) => {
      Vue.set(state, "active_cart_is_busy", status);
    },
    MUTATE_CART: (state, cartData) => {
      Vue.set(state, "cart", cartData);
    },
    MUTATE_PRODUCTS: (state, raw_products) => {
      var products = {};
      raw_products.sort((d1, d2) => {
        return d1.uuid.localeCompare(d2.uuid);
      });
      raw_products.forEach(element => {
        products[element.price.price_uuid] = element;
      });

      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));
    },
    DEPURATE_PRODUCTS: state => {
      var products = getCartProductsInLocalStorage();
      Object.entries(products)
        .filter(item => !item[1].dirty)
        .forEach(item => delete products[item[0]]);
      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));
    },
    MUTATE_PRODUCT_QUANTITY: (state, payload) => {
      var products = getCartProductsInLocalStorage();
      var quantity = Number(payload.quantity);
      if (!products[payload.price_uuid]) {
        return;
      }
      products[payload.price_uuid].quantity = quantity;
      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));
    },
    MUTATE_ITEM_UUID: (state, payload) => {
      var products = getCartProductsInLocalStorage();
      var price_uuid = get(payload, "item.price.price_uuid");
      if (!products[price_uuid]) {
        return;
      }
      products[price_uuid].uuid = payload.item.uuid;
      products[price_uuid].dirty = false;
      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));
    },
    MUTATE_NEW_PRODUCT: (state, payload) => {
      var products = getCartProductsInLocalStorage();
      var price_uuid = get(payload, "product.price.uuid");
      var quantity = Number(payload.product.quantity);

      if (products[price_uuid]) {
        products[price_uuid].quantity += quantity;
      } else {
        products[price_uuid] = payload.product;
      }

      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));
    },
    MUTATE_REMOVE_PRODUCT: (state, payload) => {
      // Quitamos el producto del carrito
      var products = getCartProductsInLocalStorage();
      delete products[payload.price_uuid];
      Vue.set(state, "products", products);
      localStorage.setItem("shoppingcartproducts", JSON.stringify(products));

      // Lo quitamos también de cartData
      // cartData se suele recargar en las vistas que lo usan, pero por si acaso
      if (state.cart.item_list) {
        var drugs = state.cart.item_list.drugs.filter(drug => {
          return drug.price.price_uuid !== payload.price_uuid;
        });
        Vue.set(state.cart.item_list, "drugs", drugs);
      }
    },
    MUTATE_SHOPPING_CART_FROM_LOCALSTORAGE: state => {
      Vue.set(state, "active_cart_is_busy", true);
      Vue.set(state, "products", getCartProductsInLocalStorage());
      Vue.set(state, "active_cart_is_busy", false);
    },
    NOTIFY: state => {
      Vue.set(state, "notify", Date.now());
    },
  },
  getters: {
    cartData: state => {
      return state.cart;
    },
    cartProducts: state => {
      return state.products;
    },
    cartNotification: state => {
      return state.notify;
    },
  },
};
